import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "native-base";
import { tooltipArrow, tooltipContentBox } from "./useStyles";
export default function Tooltip({ children, styleArrow = {}, styleContentBox = {}, tooltip = {}, transform = [{ translateX: -120 }, { translateY: -12 }], needsArrow = true, }) {
    const { onShow = false, left = 0, bottom = 0 } = tooltip;
    return (_jsx(Box, Object.assign({ display: onShow ? "flex" : "none", position: "absolute", zIndex: 3, style: {
            bottom,
            left,
            transform,
        } }, { children: _jsxs(Box, Object.assign({ style: [tooltipContentBox, styleContentBox] }, { children: [children, needsArrow && _jsx(Box, { style: [tooltipArrow, styleArrow] })] })) })));
}
